import React from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from '../../shared/hooks/useAuth';
import { getUserRole } from '../../utils/roles';

/**
 * PublicRoute - Wrapper for public routes (login, register, etc.)
 * Redirects to appropriate page based on user role if already authenticated
 */
const PublicRoute: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (isAuthenticated) {
    // Redirect based on user role
    // Customer (role_id: 4) should go to subscriptions page
    // All other roles go to dashboard
    const userRole = getUserRole();
    const defaultRoute = userRole === 4 ? '/subscriptions' : '/dashboard';
    const from = (location.state as any)?.from?.pathname || defaultRoute;
    return <Navigate to={from} replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
export { PublicRoute };
